import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Pagination } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  addLikePost,
  fetchDetailPost,
  likeUnlikeComment,
  postComment,
  postsSelector,
  removeComment,
} from "../../../../service/redux/posts/postsSlice";
import { Auth } from "../../../../service/utils/auth";
import config from "../../../../configs/Configs.json";
import axios from "axios";
import { toast } from "react-toastify";
import { quillModules } from "../../../../components/shared/quillConfig";

// Import components con
import PostDetailHeader from "./components/PostDetailHeader";
import PostContent from "./components/PostContent";
import CommentItem from "./components/CommentItem";
import CommentForm from "./components/CommentForm";
import EditCommentModal from "./components/EditCommentModal";

const { API__SERVER } = config;

// Custom handler cho image upload
const handleImageClick = () => {
  alert("Chức năng upload ảnh tạm thời chưa khả dụng!");
};
quillModules.toolbar.handlers.image = handleImageClick;

function DetailPost() {
  const { slug, threadID, groupId } = useParams();
  const { userID } = new Auth();

  // State cho pagination
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // State cho comments
  const [listComment, setListComment] = useState([]);

  // State cho images
  const [imageBase64s, setImageBase64s] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);

  // State cho UI
  const [showEmoji, setShowEmoji] = useState(false);
  const [groupName, setGroupName] = useState("");

  // State cho comment chính
  const [dataThisComment, setDataThisComment] = useState({
    Comment: "",
    PhotoURL: "",
  });

  // State cho post data
  const [postData, setPostData] = useState(null);

  // State cho reply
  const [replyingPost, setReplyingPost] = useState(null);
  const [replyingQuote, setReplyingQuote] = useState("");

  // State cho edit comment
  const [isShowEditComment, setIsShowEditComment] = useState(false);
  const [editCommentContent, setEditCommentContent] = useState("");
  const [editCommentId, setEditCommentId] = useState(null);

  // State cho prevent clearing images
  const [hasSubmittedComment, setHasSubmittedComment] = useState(false);

  // Refs
  const commentTextareaRef = useRef();
  const inputSectionRef = useRef();
  const prevReplyingQuote = useRef(replyingQuote);

  // Redux
  const { changeTogglePost } = useSelector(postsSelector);
  const dispatch = useDispatch();

  // Handler: Emoji cho ReactQuill
  const handleEmojiClickQuill = (emojiData) => {
    const quill = commentTextareaRef.current.getEditor();
    const range = quill.getSelection();
    quill.insertText(range ? range.index : 0, emojiData.emoji);
    setShowEmoji(false);
  };

  // Handler: Emoji cho sub-comment
  const handleEmojiClick = (data) => {
    const CommentID = window.localStorage.getItem("ThisCommentID");
    if (CommentID) {
      setDataThisComment((prev) => ({
        ...prev,
        [CommentID]: {
          ...prev[CommentID],
          Content: prev[CommentID].Content + data.emoji,
        },
      }));
      setShowEmoji(false);
    }
  };

  // Handler: Submit comment chính
  const handleSubmitFormPost = () => {
    const { Comment } = dataThisComment;
    if (!Comment) {
      setDataThisComment((prev) => ({
        ...prev,
        warnComment: !Comment ? "Trường này không được để trống!" : "",
      }));
    } else {
      const formData = new FormData();
      let contentToSend = Comment;
      if (replyingQuote) {
        contentToSend = `[QUOTE]${replyingQuote}[/QUOTE]\n\n${Comment}`;
      }
      formData.append("Content", contentToSend);
      imageFiles.forEach((file) => formData.append("PhotoURL", file));
      setHasSubmittedComment(true);
      dispatch(postComment({ PostID: threadID, data: formData, userID })).then(
        () => {
          setDataThisComment((prev) => ({ ...prev, Comment: "" }));
          setReplyingPost(null);
          setReplyingQuote("");
          setImageBase64s([]);
          setImageFiles([]);
          setHasSubmittedComment(false);
        }
      );
    }
  };

  // Handler: Upload ảnh cho comment chính
  const handlePushImage = async (e) => {
    let file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64Url = reader.result;
      setImageBase64s((prev) => [...prev, base64Url]);
      setImageFiles((prev) => [...prev, file]);
    };
  };

  // Handler: Xóa ảnh preview
  const handleDeleteListImage = async (index) => {
    const newImageBase64s = [...imageBase64s];
    const newImageFiles = [...imageFiles];
    newImageBase64s.splice(index, 1);
    newImageFiles.splice(index, 1);
    setImageBase64s(newImageBase64s);
    setImageFiles(newImageFiles);
  };

  // Handler: Submit sub-comment
  const handleSubmitSendSubComment = async (commentID) => {
    if (commentID) {
      if (dataThisComment[commentID]?.Content) {
        const formData = new FormData();
        formData.append("Content", dataThisComment[commentID]?.Content);
        formData.append("PhotoURL", dataThisComment[commentID]?.PhotoURL);
        formData.append("ReplyID", commentID);

        // Debug: Log FormData
        console.log("🚀 Submit Sub-Comment:");
        console.log("  - PostID:", threadID);
        console.log("  - UserID:", userID);
        console.log("  - Parent CommentID (ReplyID):", commentID);
        console.log("  - Content:", dataThisComment[commentID]?.Content);
        console.log("  - Has Photo:", !!dataThisComment[commentID]?.PhotoURL);

        await dispatch(
          postComment({ PostID: threadID, data: formData, userID })
        );

        // Reset form state
        setDataThisComment((prev) => ({
          ...prev,
          [commentID]: {
            ...prev[commentID],
            Content: "",
            PhotoURL: "",
            base64Url: "",
          },
        }));

        // Reload comments để hiển thị reply mới
        await fetchComments();

        toast.success("Đã trả lời comment!");
      }
    }
  };

  // Handler: Upload ảnh cho sub-comment
  const handlePushSubCommentImage = async (e, CommentID) => {
    let file = e?.target?.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64Url = reader.result;
      setDataThisComment((prev) => ({
        ...prev,
        [CommentID]: {
          ...prev[CommentID],
          base64Url,
          PhotoURL: file,
        },
      }));
    };
  };

  // Handler: Xóa ảnh sub-comment
  const handleDeleteImageSubImage = (CommentID) => {
    setDataThisComment((prev) => ({
      ...prev,
      [CommentID]: {
        ...prev[CommentID],
        base64Url: "",
        PhotoURL: "",
      },
    }));
  };

  // Handler: Mở modal edit comment
  const handleOpenEditComment = (comment) => {
    setEditCommentId(comment.CommentID);
    const htmlContent = comment.Content || "";
    const htmlWithNewline = htmlContent.replace(/<br\s*\/?>/gi, "\n");
    const plain = htmlWithNewline
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ");
    let content = "";
    if (plain.startsWith("[QUOTE]") && plain.includes("[/QUOTE]")) {
      const endIdx = plain.indexOf("[/QUOTE]");
      content = plain.substring(endIdx + 8).trim();
    } else {
      content = plain;
    }
    setEditCommentContent(content);
    setIsShowEditComment(true);
  };

  // Handler: Submit edit comment
  const handleSubmitEditComment = async () => {
    if (!editCommentContent) return;
    const formData = new FormData();
    formData.append("Content", editCommentContent);
    try {
      await axios.post(
        `${API__SERVER}/forum/comment/update/${editCommentId}`,
        formData
      );
      setIsShowEditComment(false);
      setEditCommentContent("");
      setEditCommentId(null);
      dispatch(fetchDetailPost({ groupId, postId: threadID, userID }));
      await fetchComments();
    } catch (e) {
      toast.error("Cập nhật comment thất bại!");
    }
  };

  // Handler: Reply to post/comment
  const handleReplyToPost = () => {
    let content = postData.Content;
    if (content.startsWith("[QUOTE]")) {
      const endIdx = content.indexOf("[/QUOTE]");
      content = content.substring(endIdx + 8).trim();
    }
    setReplyingPost(postData);
    setReplyingQuote(content);
    setDataThisComment((prev) => ({ ...prev, Comment: "" }));
    setTimeout(() => {
      commentTextareaRef.current && commentTextareaRef.current.focus();
      inputSectionRef.current &&
        inputSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  const handleReplyToComment = (comment) => {
    // Set state để show form reply của comment này
    setDataThisComment((prev) => ({
      ...prev,
      [comment.CommentID]: {
        ...prev[comment.CommentID],
        isShowID: comment.CommentID, // Key để hiển thị form reply
        Content: prev[comment.CommentID]?.Content || "",
      },
    }));

    // Scroll đến comment
    setTimeout(() => {
      const commentElement = document.querySelector(
        `[data-comment-id="${comment.CommentID}"]`
      );
      if (commentElement) {
        commentElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };

  // Fetch comments
  const fetchComments = async () => {
    const { data } = await axios
      .get(
        `${API__SERVER}/forum/comment/${threadID}/${userID}/${limit}?page=${page}`
      )
      .catch(() => toast.error("Get list of comments failed!"));
    if (Array.isArray(data?.Comments)) {
      const uniqueComments = data.Comments.reduce((acc, curr) => {
        const foundIdx = acc.findIndex((x) => x.CommentID === curr.CommentID);
        if (foundIdx === -1) {
          acc.push(curr);
        } else {
          const existing = acc[foundIdx];
          const hasImage = (c) =>
            (Array.isArray(c.Photo) && c.Photo.length > 0) ||
            (Array.isArray(c.PhotoURL) && c.PhotoURL.length > 0);
          if (!hasImage(existing) && hasImage(curr)) {
            acc[foundIdx] = curr;
          }
        }
        return acc;
      }, []);
      setListComment(uniqueComments);
      setTotalPage(Math.ceil(data?.total_page ?? 0));
    }
  };

  // useEffect: Fetch comments
  useEffect(() => {
    fetchComments();
  }, [changeTogglePost, page, threadID, userID, limit]);

  // useEffect: Fetch group name
  useEffect(() => {
    if (groupId) {
      axios
        .get(`https://iudi-api.thinkdiff.us/api/detail_group/${groupId}/1`)
        .then((res) => {
          setGroupName(res.data?.detailGroup?.GroupName || "");
        })
        .catch(() => setGroupName(""));
    }
  }, [groupId]);

  // useEffect: Fetch post detail
  useEffect(() => {
    async function fetchPostDetail() {
      let found = null;
      let page = 1;
      const limit = 10;
      while (!found) {
        const { data } = await axios.get(
          `https://iudi-api.thinkdiff.us/api/forum/group/${groupId}/${page}/${limit}/${userID}`
        );
        if (!Array.isArray(data?.list_posts) || data.list_posts.length === 0)
          break;
        found = data.list_posts.find(
          (item) => String(item.PostID) === String(threadID)
        );
        if (found) break;
        page++;
      }
      setPostData(found || null);
    }
    fetchPostDetail();
  }, [threadID, groupId, userID]);

  // useEffect: Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect: Reset images when quote changes
  useEffect(() => {
    if (prevReplyingQuote.current !== replyingQuote && replyingQuote !== "") {
      setImageBase64s([]);
      setImageFiles([]);
    }
    prevReplyingQuote.current = replyingQuote;
  }, [replyingQuote]);

  return (
    <div className="w-full h-full p-8 backdrop:blur-md bg-black/50 text-white mt-4 relative">
      {/* Header: Breadcrumb + Title + Author */}
      <PostDetailHeader
        groupName={groupName}
        slug={slug}
        groupId={groupId}
        postData={postData}
      />

      {/* Pagination Top */}
      <div className="w-full flex justify-between items-center mb-2">
        <div className="mt-3 py-2 rounded-xl">
          {totalPage >= 2 && (
            <Pagination
              colorText="#fff"
              total={totalPage * limit}
              pageSize={limit}
              current={Number(page)}
              onChange={(page) => setPage(page)}
              showLessItems={false}
              showQuickJumper={false}
              showSizeChanger={false}
              align="start"
              className="text-white custom-pagination"
            />
          )}
        </div>
      </div>

      {/* Main Post Content */}
      <PostContent
        postData={postData}
        onLike={() =>
          dispatch(addLikePost({ postId: postData?.PostID, userID }))
        }
        onReply={handleReplyToPost}
      />

      {/* Comments List */}
      {Array.isArray(listComment) &&
        listComment.length > 0 &&
        listComment
          .slice()
          .reverse()
          .map((dataComment, i) => (
            <CommentItem
              key={i}
              comment={dataComment}
              index={i}
              userID={userID}
              onLike={(commentID) =>
                dispatch(likeUnlikeComment({ commentID, userID }))
              }
              onDelete={(commentID) => {
                const IsExist = window.confirm(
                  "Bạn chắc chắn muốn xóa comment này?"
                );
                if (IsExist) {
                  dispatch(removeComment(commentID));
                }
              }}
              onEdit={handleOpenEditComment}
              onReply={handleReplyToComment}
              dataThisComment={dataThisComment}
              onSubCommentChange={(commentID, value) => {
                setDataThisComment((prev) => ({
                  ...prev,
                  [commentID]: {
                    ...prev[commentID],
                    Content: value,
                  },
                }));
              }}
              onSubCommentImageUpload={handlePushSubCommentImage}
              onDeleteSubCommentImage={handleDeleteImageSubImage}
              onSubmitSubComment={handleSubmitSendSubComment}
              showEmoji={showEmoji}
              onToggleEmoji={() => setShowEmoji(!showEmoji)}
              onEmojiClick={handleEmojiClick}
              commentTextareaRef={commentTextareaRef}
            />
          ))}

      {/* Comment Form */}
      <CommentForm
        postData={postData}
        commentContent={dataThisComment.Comment}
        onCommentChange={(value) =>
          setDataThisComment((prev) => ({
            ...prev,
            Comment: value,
            warnComment: "",
          }))
        }
        imageBase64s={imageBase64s}
        onImageUpload={handlePushImage}
        onImageDelete={handleDeleteListImage}
        onSubmit={handleSubmitFormPost}
        showEmoji={showEmoji}
        onToggleEmoji={() => setShowEmoji(!showEmoji)}
        onEmojiClick={handleEmojiClickQuill}
        replyingQuote={replyingQuote}
        onCloseQuote={() => {
          setReplyingQuote("");
          setReplyingPost(null);
        }}
        commentTextareaRef={commentTextareaRef}
        inputSectionRef={inputSectionRef}
        handleImageClick={handleImageClick}
      />

      {/* Pagination Bottom */}
      <div className="w-full flex justify-center items-center">
        <div className="mt-3 py-2 rounded-xl">
          <Pagination
            colorText="#fff"
            total={totalPage * limit}
            pageSize={limit}
            current={Number(page)}
            onChange={(page) => setPage(page)}
            showLessItems={false}
            showQuickJumper={false}
            showSizeChanger={false}
            align="start"
            className="text-white custom-pagination"
          />
        </div>
      </div>

      {/* Edit Comment Modal */}
      <EditCommentModal
        isOpen={isShowEditComment}
        onClose={() => setIsShowEditComment(false)}
        commentId={editCommentId}
        content={editCommentContent}
        onChange={setEditCommentContent}
        onSubmit={handleSubmitEditComment}
      />

      {/* Global Styles */}
      <style>
        {`
        .custom-tooltip {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -2.5rem; 
          background: #2d3748; 
          color: #ffffff; 
          font-size: 0.85rem; 
          font-weight: 500; 
          border-radius: 0.375rem; 
          padding: 0.5rem 0.75rem; 
          opacity: 0;
          transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out; 
          transform: translateX(-50%) translateY(5px); 
          z-index: 50;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); 
          border: 1px solid rgba(255, 255, 255, 0.1); 
        }
        .ql-toolbar button:hover .custom-tooltip,
        .ql-toolbar span:hover .custom-tooltip {
          opacity: 1;
          transform: translateX(-50%) translateY(0); 
        }
        
        .comment-content {
          color: #ffffff;
        }
        .comment-content h1 { font-size: 1.5rem; font-weight: bold; margin: 0.5rem 0; }
        .comment-content h2 { font-size: 1.25rem; font-weight: bold; margin: 0.5rem 0; }
        .comment-content h3 { font-size: 1.125rem; font-weight: bold; margin: 0.5rem 0; }
        .comment-content ul { list-style-type: disc; margin: 0.5rem 0; padding-left: 1.5rem; }
        .comment-content ol { list-style-type: decimal; margin: 0.5rem 0; padding-left: 1.5rem; }
        .comment-content li { margin: 0.25rem 0; }
        .comment-content blockquote { border-left: 4px solid #4a5568; padding-left: 1rem; margin: 0.5rem 0; font-style: italic; color: #a0aec0; }
        .comment-content p { margin: 0.5rem 0; }
        .comment-content strong { font-weight: bold; }
        .comment-content em { font-style: italic; }
        .comment-content u { text-decoration: underline; }
        .comment-content s { text-decoration: line-through; }
        .comment-content a { color: #63b3ed; text-decoration: underline; }
        .comment-content a:hover { color: #4299e1; }
        
        .post-content h1, .ql-editor h1 { font-size: 2rem; font-weight: bold; margin: 0.5em 0; }
        .post-content h2, .ql-editor h2 { font-size: 1.5rem; font-weight: bold; margin: 0.5em 0; }
        .post-content h3, .ql-editor h3 { font-size: 1.2rem; font-weight: bold; margin: 0.5em 0; }
        .post-content ul, .ql-editor ul { list-style-type: disc; margin-left: 2em; }
        .post-content ol, .ql-editor ol { list-style-type: decimal; margin-left: 2em; }
        .post-content li, .ql-editor li { margin: 0.25em 0; }
        .post-content blockquote, .ql-editor blockquote { border-left: 4px solid #4a5568; padding-left: 1em; color: #a0aec0; font-style: italic; margin: 0.5em 0; }
        
        .main-comment-quill .ql-editor { min-height: 150px !important; height: 150px !important; max-height: 300px !important; overflow-y: auto !important; }
      `}
      </style>
    </div>
  );
}

export default DetailPost;
